import { render } from "./RightContainer.vue?vue&type=template&id=720046a0&scoped=true"
const script = {}

import "./RightContainer.vue?vue&type=style&index=0&id=720046a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-720046a0"]])

export default __exports__